export type PreChatField = { key: string; label: string; type: string; visible: boolean; required: boolean; maxLength: number };
export const defaultPreChatFields: PreChatField[] = [
  { key: "name", label: "Name", type: "text", visible: true, required: true, maxLength: 80 },
  { key: "email", label: "Email", type: "email", visible: true, required: true, maxLength: 254 },
  { key: "phone", label: "Phone", type: "tel", visible: true, required: true, maxLength: 32 },
  { key: "countryCode", label: "Country dialling code", type: "text", visible: true, required: true, maxLength: 5 },
  { key: "consent", label: "I consent to my contact details being used to respond to my enquiry.", type: "checkbox", visible: true, required: true, maxLength: 0 },
];
export function effectivePreChatFields(value?: PreChatField[]) {
  return Array.isArray(value) && defaultPreChatFields.every(d => value.some(f => f.key === d.key))
    ? value : defaultPreChatFields;
}
